export default (params) => ({
  trigger: {
    name: 'store_stock_overlay.select_store_location',
    params: params,
  },
  config: {
    schema: {
      store_id: {
        type: 'integer',
      },
      store_name: {
        type: 'string',
      },
    },
    event: {
      name: 'select_store',
      params: {
        sub_feature: 'generic_store_stock_overlay',
      },
    },
  },
});
